import { EventLineType, ImportExportEventType } from "../constants"
import { timeToFraction, danoniGetFrzName } from "../utilFunctions"

// --------------------------------------------------------
// EXPORT
// --------------------------------------------------------

export const exportHandlerDanoni = {
  finally: (_state, chartObj) => {

    const {
      chartParameters: chartParameters_,
    } = chartObj

    const chartParameters = chartParameters_.value

    const blankFrame = chartParameters.blankFrame == null || isNaN(Number(chartParameters.blankFrame)) ? 200 : chartParameters.blankFrame
    let scoreNumber = chartParameters.scoreNumber == null || isNaN(parseInt(chartParameters.scoreNumber)) ? 1 : parseInt(chartParameters.scoreNumber)
    scoreNumber = scoreNumber <= 1 ? '' : scoreNumber

    const beatToTime = (bpm, beat) => 60 * beat / bpm
    const beatToFrame = (bpm, beat) => beatToTime(bpm, beat) * 60 + blankFrame

    const resMap = new Map()


    for (const column of chartObj.orderedCols.value) {
      if (column.name == null || column.name == "") continue

      let colNotes = chartObj.notesByColumn.get(column)
      if (colNotes == []) continue

      let resCol = resMap.get(column.name)
      if (!resCol) {
        resCol = []
        resMap.set(column.name, resCol)
      }

      colNotes = colNotes.map(x => ({ frame: Math.round(x.eventLine.time * 60 + beatToFrame(x.eventLine.bpm, x.beat)), note: x }))
      resCol.push(...colNotes)
    }


    let result = "";

    [...resMap.entries()].forEach(([key, val]) => {
      const sortedNotes = val.sort((x, y) => x.frame - y.frame)
      const r = [[], []] // [regularNotes, freezeNotes]

      for (let i = 0; i < sortedNotes.length; i++) {
        if (!sortedNotes[i].note.long) {
          r[0].push(sortedNotes[i].frame)
          continue
        }

        r[1].push(sortedNotes[i++].frame)
        if (sortedNotes[i]) r[1].push(sortedNotes[i].frame)
      }

      result += `|${key}${scoreNumber}_data=${r[0].join(',')}` + `|${danoniGetFrzName(key)}${scoreNumber}_data=${r[1].join(',')}`
    });


    const speeds = []
    const boosts = []
    chartObj.orderedEventLines.value.forEach(e => {
      if (e.speed != null && e.speed != "" && !isNaN(Number(e.speed))) {
        speeds.push(e.time * 60 + blankFrame, e.speed)
      }
      if (e.boost != null && e.boost != "" && !isNaN(Number(e.boost))) {
        boosts.push(e.time * 60 + blankFrame, e.boost)
      }
    })
    result += `|speed=${speeds.join(',')}`
    result += `|boost=${boosts.join(',')}`

    result += `|es_keyKind=${chartParameters.keyKind ?? ''}`
    result += `|es_blankFrame=${blankFrame}`
    result += `|es_scorePrefix=${chartParameters.scorePrefix ?? ''}`
    result += `|es_scoreNumber=${chartParameters.scoreNumber == '' ? 1 : chartParameters.scoreNumber}`

    let es_label = []
    let es_bpm = []
    let es_pageBlockNumber = []
    let es_startNumber = []
    chartObj.orderedCL.value.forEach((cl, i) => {
      es_label.push(i + 1)
      es_pageBlockNumber.push(cl.eventLine.pageBlockNumber)
      es_bpm.push(cl.eventLine.bpm)
      es_startNumber.push(cl.eventLine.time * 60)
    })

    result += `|es_label=${es_label.join(',')}`
    result += `|es_bpm=${es_bpm.join(',')}`
    result += `|es_pageBlockNumber=${es_pageBlockNumber.join(',')}`
    result += `|es_startNumber=${es_startNumber.join(',')}`

    return result
  }
}

// --------------------------------------------------------
// IMPORT 
// --------------------------------------------------------

export function importFunctionDanoni(chartObj, dataStr) {
  const {
    chartParameters: chartParameters_,
  } = chartObj

  const chartParameters = chartParameters_.value
  let match = null

  // key kind
  match = dataStr.match(`\\|es_keyKind=([^|\\s,.]+)`)
  if (match != null && match[1] != null) {
    chartObj.setChartParameter('keyKind', match[1])
  }

  // blank frame
  let blankFrame
  match = dataStr.match(`\\|es_blankFrame=([0-9][0-9.]*)`)
  if (match != null && match[1] != null) {
    const n = Number(match[1])
    blankFrame = isNaN(n) ? 200 : n
  } else {
    blankFrame = 200
  }
  chartObj.setChartParameter('blankFrame', blankFrame)

  // score prefix
  match = dataStr.match(`\\|es_scorePrefix=([^|.,\\s]+)`)
  let scorePrefix = ""
  if (match != null && match[1] != null) {
    scorePrefix = match[1]
    chartObj.setChartParameter('scorePrefix', scorePrefix)
  }

  // labels
  let labels = []
  match = dataStr.match(`\\|es_label=([0-9,]+)`)
  if (match != null && match[1] != null) {
    match[1].split(",").forEach(x => {
      labels.push({ label: x })
    })
  }

  // start number
  match = dataStr.match(`\\|es_startNumber=([0-9,.]+)`)
  if (match != null && match[1] != null) {
    match[1].split(",").forEach((x, i) => {
      const n = Number(x)
      if (isNaN(n) || x == '') return
      labels[i].startNumber = n / 60
    })
  }

  // bpm
  match = dataStr.match(`\\|es_bpm=([0-9,.]+)`)
  if (match != null && match[1] != null) {
    match[1].split(",").forEach((x, i) => {
      const n = Number(x)
      if (isNaN(n) || x == '') return
      labels[i].bpm = n
    })
  }

  // page block number
  match = dataStr.match(`\\|es_pageBlockNumber=([0-9,]+)`)
  if (match != null && match[1] != null) {
    match[1].split(",").forEach((x, i) => {
      const n = Number(x)
      if (isNaN(n) || x == '') return
      labels[i].pageBlockNumber = n
    })
  }

  labels.forEach(x => {
    if (x.startNumber == null && x.bpm == null && x.pageBlockNumber == null) return
    let eventLine = chartObj.orderedCL.value.find(cl => cl.eventLine.time == x.startNumber && cl.eventLine.bpm == x.bpm)?.eventLine
    if (!eventLine)
      chartObj.addEventLine(x.startNumber, EventLineType.Timing, { bpm: x.bpm, pageBlockNumber: x.pageBlockNumber })
    else {
      chartObj.setEventLineParameter(eventLine.eventLineId, 'pageBlockNumber', x.pageBlockNumber)
    }
  })

  // score number
  match = dataStr.match(`\\|es_scoreNumber=([0-9]+)`)
  let scoreNumber
  if (match != null && match[1] != null) {
    const n = Number(match[1])
    scoreNumber = isNaN(parseInt(n)) ? 1 : parseInt(n)
  } else if (chartParameters.scoreNumber == null || isNaN(parseInt(chartParameters.scoreNumber))) {
    scoreNumber = 1
  }
  chartObj.setChartParameter('scoreNumber', scoreNumber)
  scoreNumber = scoreNumber <= 1 ? '' : scoreNumber

  // speed
  match = dataStr.match(`\\|speed${scoreNumber}_data=([^'"|\\\`]*)`)
  if (match != null || match?.[1] != null && match?.[1] != "") {
    const speeds = match[1].split(',')
    for (let i = 0; i < speeds.length; i += 2) {
      let t = Number(speeds[i])
      let v = Number(speeds[i + 1])
      if (isNaN(t) || isNaN(v)) continue
      t = (t - blankFrame) / 60
      let eventLine = chartObj.orderedEventLines.value.find(e => e.time == t)
      if (!eventLine) chartObj.addEventLine(t, EventLineType.Generic, { speed: v })
      else chartObj.setEventLineParameter(eventLine.eventLineId, 'speed', v)
    }
  }

  // boost
  match = dataStr.match(`\\|boost${scoreNumber}_data=([^'"|\\\`]*)`)
  if (match != null || match?.[1] != null && match?.[1] != "") {
    const boosts = match[1].split(',')
    for (let i = 0; i < boosts.length; i += 2) {
      let t = Number(boosts[i])
      let v = Number(boosts[i + 1])
      if (isNaN(t) || isNaN(v)) continue
      t = (t - blankFrame) / 60
      let eventLine = chartObj.orderedEventLines.value.find(e => e.time == t)
      if (!eventLine) chartObj.addEventLine(t, EventLineType.Generic, { boost: v })
      else chartObj.setEventLineParameter(eventLine.eventLineId, 'boost', v)
    }
  } 

  const keys = new Set(chartObj.columns.value.values().filter(x => x.name != "").map(x => scorePrefix.concat(x.name)))
  const keyNoteTimes = new Map()

  for (const k of keys) {
    const freezeK = danoniGetFrzName(k)

    match = dataStr.match(`\\|${k}${scoreNumber}_data=([^'"|\\\`]*)`)
    const times = []
    match?.[1]?.split(",")?.forEach(e => {
      const n = Number(e)
      if (isNaN(n) || e == '') return
      times.push([(n - blankFrame) / 60, 0])
    })

    match = dataStr.match(`\\|${freezeK}${scoreNumber}_data=([^'"|\\\`]*)`)
    const freezeTimes = []
    match?.[1]?.split(",")?.forEach(e => {
      const n = Number(e)
      if (isNaN(n) || e == '') return
      freezeTimes.push([(n - blankFrame) / 60, 1])
    })

    keyNoteTimes.set(k, times.concat(freezeTimes).sort((x, y) => x[0] - y[0]))
  }

  for (const cl of chartObj.orderedCL.value) {
    for (const col of chartObj.orderedCols.value) {
      if (col.name == "") continue

      const k = scorePrefix.concat(col.name)
      let noteTimes = keyNoteTimes.get(k)
      const [outside, inside] = noteTimes.reduce((a, x) => {
        if (x[0] < cl.eventLine.time || x[0] >= cl.endTime) a[0].push(x);
        else a[1].push(x);
        return a;
      }, [[], []]);
      keyNoteTimes.set(k, outside)
      inside.forEach(([t, isFrz]) => {
        const beat = timeToFraction(cl.eventLine.bpm, t - cl.eventLine.time)
        chartObj.addNote(cl.eventLine, col.columnIndex, beat[0], beat[1], isFrz ? { long: 'x' } : {})
      })
    }
  }
}
